import queryClient from '@/utils/reactQueryClient';
import type {CampaignCreatorCounts} from '@/views/campaigns/creators-tab/types/creatorTabTypes';

function updateCreatorCounts(
  campaignId: string | undefined,
  brandId: string | undefined,
  adjustment: Partial<CampaignCreatorCounts>
) {
  queryClient.setQueriesData<{data: CampaignCreatorCounts}>(
    {queryKey: ['campaignV2CreatorsCounts', {campaignId, brandId}]},
    (old) => {
      if (!old?.data) return old;
      return {
        ...old,
        data: {
          ...old.data,
          applications: old.data.applications + (adjustment.applications ?? 0),
          hired: old.data.hired + (adjustment.hired ?? 0),
          declined: old.data.declined + (adjustment.declined ?? 0),
        },
      };
    }
  );
}

export default updateCreatorCounts;
